import {
	fetchPlayerDetailFailed,
	fetchPlayerDetailSuccess,
	globalError,
	type fetchPlayerDetail,
	type fetchPlayerSeasonStats,
	fetchPlayerSeasonStatsSuccess,
	fetchPlayerSeasonStatsFailed,
} from "modules/actions";

import Api from "modules/utils/Api";
import apiError from "modules/utils/Api/ApiError";
import {captureSentryError} from "modules/utils/sentry";
import {call, put} from "typed-redux-saga/macro";

export const fetchPlayerDetailSaga = function* (action: ReturnType<typeof fetchPlayerDetail>) {
	try {
		const {playerId, unitId, pitcherId} = action.payload;
		const response = yield* call(Api.Player.detail, playerId, unitId, pitcherId);

		apiError.CHECK(response.data);

		if (response.data.success) {
			yield* put(fetchPlayerDetailSuccess(response.data.success));
		}
	} catch (e) {
		captureSentryError("fetchPlayerDetailSaga", action, e);
		yield* put(globalError(e));
		yield* put(fetchPlayerDetailFailed());
	}
};

export const fetchPlayerSeasonStatsSaga = function* (
	action: ReturnType<typeof fetchPlayerSeasonStats>
) {
	try {
		const {playerId} = action.payload;
		console.log("asdasd");
		const response = yield* call(Api.Player.season_stats, playerId);

		apiError.CHECK(response.data);

		if (response.data.success) {
			yield* put(fetchPlayerSeasonStatsSuccess(response.data.success));
		}
	} catch (e) {
		captureSentryError("fetchPlayerSeasonStatsSaga", action, e);
		yield* put(globalError(e));
		yield* put(fetchPlayerSeasonStatsFailed());
	}
};
